<template>
  	<div class="stores">
    	<div class="breadcrumb">修改密码</div>
    	<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" label-width="80px">
		  	<el-form-item label="原密码" prop="oldPassword">
		    	<el-input v-model="ruleForm.oldPassword" type="password" style="width:350px"></el-input>
		  	</el-form-item>
		  	<el-form-item label="新密码" prop="newPassword">
		    	<el-input v-model="ruleForm.newPassword" type="password" style="width:350px"></el-input>
		  	</el-form-item>
		  	<el-form-item label="确认密码">
		    	<el-input v-model="newPasswords" type="password" style="width:350px"></el-input>
		  	</el-form-item>
		  	<el-form-item>
			    <el-button type="primary" @click="onSubmit">确认修改</el-button>
		  	</el-form-item>
		</el-form>
    	
  	</div>
</template>

<script>
import md5 from "js-md5";
export default {
  	name: 'ForgotPassword',
  	data () {
	    return {
	    	ruleForm:{
	    		oldPassword:'',
	    		newPassword:''
	    	},
	    	ruleForms: {
		        oldPassword: [{ required: true, message: "请输入原密码"}],
		        newPassword: [{ required: true, message: "请输入新密码" }] 
	      	},
	      	newPasswords:''
	    }
  	},
  	methods:{
		onSubmit(){
			var passreg=/^[0-9a-zA-Z]{6,32}$/,that=this;
			if(!that.ruleForm.oldPassword){
				that.$message({
	              	message: '请输入原密码',
	              	type: "warning"
	            });
	            return false;
			}else if(!that.ruleForm.newPassword){
				that.$message({
	              	message: '请输入新密码',
	              	type: "warning"
	            });
	            return false;
			}else if(!passreg.test(that.ruleForm.newPassword)){
				that.$message({
	              	message: '请输入6位-32位的密码',
	              	type: "warning"
	            });
	            return false;
			}else if(!(that.ruleForm.newPassword==that.newPasswords)){
				that.$message({
	              	message: '两次密码输入不同',
	              	type: "warning"
	            });
	            return false;
			}else{
				let Params = {
		            oldPassword: md5(that.ruleForm.oldPassword),
		            newPassword: md5(that.ruleForm.newPassword)
          		};
				that.$axios.put("/users/changePassword/" + localStorage.getItem("userId"),JSON.stringify(Params))
	            .then(res => {
	            	console.log(res)
	                if (res.data.code == 0) {
	                	localStorage.removeItem('token')
	                	that.$message({
			              	message: "修改成功",
			              	type: "success",
			              	duration:1500,
				          	onClose:function(){
				          		that.$router.push({ path: "/login" });
				          	}
			            });
	                } else {
	                  	that.$message({
	                    	message: res.data.message,
	                    	type: "warning"
	                  	});
	                  	return false;
	                }
	            })
			}
		}
  	},
  	mounted() {
    
  	},
}
</script>
<style scoped>
.login_con{
  max-width: 400px;
  margin: 0 auto;
}
.login_con input{
  border:1px solid #ccc;
  display: block;
  padding: 12px 10px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px
}
.login_input{
  overflow: hidden;
}
.login_con .input_2{
  width: 64%;
  float: left;
}
.login_con .input_3{
  width: 35%;
  float:right;
  background: rgb(64, 158, 255);
  color: #fff;
  padding: 11px 10px;
}
.login_con button{
  background:rgb(64, 158, 255);
  color: #fff;
  border:none;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
  letter-spacing: 2px;
}
.login_tit{
  margin-bottom: 5px;
  font-size: 14px;
  color: #333
}
.login_con .gray{
	background-color:#ccc;
}

</style>



// WEBPACK FOOTER //
// src/views/forgotPassword/index.vue